<div class="owfc">
  <div class="owfc_naglowek">
    <h2 mat-dialog-title>Kontrahenci z plikami</h2>
    <span class="owfc_licznik">{{ lista.length }}</span>
    <button mat-icon-button class="owfc_zamknij" (click)="zamknij()" title="Zamknij">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="owfc_dodaj">
      <mat-form-field appearance="outline" class="owfc_pole">
        <mat-label>Nowy numer kontrahenta</mat-label>
        <input matInput maxlength="20" [(ngModel)]="nowyNumer" (keyup.enter)="dodaj()" [disabled]="zapisuje" autocomplete="off">
      </mat-form-field>
      <button mat-flat-button color="primary" (click)="dodaj()" [disabled]="zapisuje || nowyNumer.trim() === ''">
        <mat-icon>add</mat-icon> Dodaj
      </button>
    </div>

    <mat-form-field appearance="outline" class="owfc_pole owfc_szukaj">
      <mat-label>Szukaj</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="szukaj" autocomplete="off">
      <button *ngIf="szukaj" mat-icon-button matSuffix (click)="szukaj = ''" title="Wyczyść">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <div class="owfc_blad" *ngIf="blad">
      <mat-icon>error_outline</mat-icon><span>{{ blad }}</span>
    </div>
    <div class="owfc_komunikat" *ngIf="komunikat">
      <mat-icon>check_circle_outline</mat-icon><span>{{ komunikat }}</span>
    </div>

    <mat-progress-bar *ngIf="wczytywanie || zapisuje" mode="indeterminate"></mat-progress-bar>

    <div class="owfc_lista" *ngIf="!wczytywanie">
      <div class="owfc_pusto" *ngIf="przefiltrowana.length === 0">
        {{ lista.length === 0 ? 'Lista jest pusta' : 'Brak wyników dla „' + szukaj + '”' }}
      </div>

      <div class="owfc_wiersz" *ngFor="let item of przefiltrowana" [class.owfc_wiersz_usuwany]="usuwanyId === item.Id">

        <ng-container *ngIf="edytowanyId !== item.Id && usuwanyId !== item.Id">
          <span class="owfc_numer">{{ item.Numer }}</span>
          <button mat-icon-button (click)="edytuj(item)" [disabled]="zapisuje" title="Edytuj">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="potwierdzUsuniecie(item)" [disabled]="zapisuje" title="Usuń">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </ng-container>

        <ng-container *ngIf="edytowanyId === item.Id">
          <input #edycjaInput class="owfc_edycja" maxlength="20" [(ngModel)]="edytowanyNumer"
                 (keyup.enter)="zapiszEdycje(item)" (keyup.escape)="anulujEdycje()" [disabled]="zapisuje">
          <button mat-icon-button color="primary" (click)="zapiszEdycje(item)" [disabled]="zapisuje || edytowanyNumer.trim() === ''" title="Zapisz">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button (click)="anulujEdycje()" [disabled]="zapisuje" title="Anuluj">
            <mat-icon>undo</mat-icon>
          </button>
        </ng-container>

        <ng-container *ngIf="usuwanyId === item.Id">
          <span class="owfc_numer">Usunąć <b>{{ item.Numer }}</b>?</span>
          <button mat-stroked-button color="warn" (click)="usun(item)" [disabled]="zapisuje">Usuń</button>
          <button mat-button (click)="usuwanyId = null" [disabled]="zapisuje">Anuluj</button>
        </ng-container>

      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <span class="owfc_stopka" *ngIf="szukaj">Pokazano {{ przefiltrowana.length }} z {{ lista.length }}</span>
    <button mat-flat-button (click)="zamknij()">Zamknij</button>
  </mat-dialog-actions>
</div>
